import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconResultsStyle0 = cosmosIconCss;

const CosmosIconResults$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconResults extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '37ea5756bbf1bef16efec350a8621c08526ec97c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b7b101baa11149803724cadd046c146e9af8a487', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8ab5da4d4da9164e87bfe680337140246b0ba62f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.93 4.06 1.9.16c.3.04.37.21.13.38l-1.5 1.28L13 7.7c.09.28-.05.39-.29.22L11 6.84 9.3 7.92c-.3.17-.39.06-.3-.22l.57-1.87-1.51-1.27c-.24-.18-.18-.39.12-.39L10.1 4l.66-1.73c.1-.28.28-.28.4 0l.77 1.79ZM7.5 10a.5.5 0 0 0-.5.5V14H2.51a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H15v-3.5a.5.5 0 0 0-.5-.5h-7Zm6.01 1.5V15a.5.5 0 0 0 .5.5h4.5v3h-15v-3H8a.5.5 0 0 0 .5-.5v-3.5h5.01Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconResultsStyle0; }
}, [1, "cosmos-icon-results", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-results"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-results":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconResults$1);
            }
            break;
    } });
}

const CosmosIconResults = CosmosIconResults$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconResults, defineCustomElement };
